import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// login
import login from '@/pages/login'

// 首页
import dashboard from '@/pages/dashboard'
import index from '@/pages/index'

// 新闻／活动
import news from '@/pages/news/index'
import newsList from '@/pages/news/list'
import newsDetails from '@/pages/news/details'

// 业务平台
import business from '@/pages/business/index'
import businessList from '@/pages/business/list'

// 实验室
import experiment from '@/pages/experiment/index'
import experimentList from '@/pages/experiment/list'

// 投资我们
import invest from '@/pages/invest/index'
import investList from '@/pages/invest/list'

// 关于我们
import about from '@/pages/about/index'
import aboutList from '@/pages/about/list'

// 生成报表
import reports from '@/pages/reports/index'
import reportsList from '@/pages/reports/list'

// user
import user from '@/pages/user/index'
import userList from '@/pages/user/list'

export default new Router({
    routes: [
        {
            path: '/login',
            name: 'login',
            component: login
        },
        {
            path: '/',
            redirect: {name: 'index'},
            component: dashboard,
            children: [
                {
                    path: '/',
                    name: 'index',
                    component: index,
                    // meta: {
                    //     requireAuth: true,
                    //     isSidebar: true,
                    // },
                },
                {
                    // news
                    path: '/news',
                    redirect: {name: 'newsList'},
                    component: news,
                    children: [
                        {
                            path: '/news/list',
                            name: 'newsList',
                            component: newsList,
                        },
                        {
                            path: '/news/details',
                            name: 'newsDetails',
                            component: newsDetails,
                        }
                    ]
                },
                {
                    // business
                    path: '/business',
                    redirect: {name: 'businessList'},
                    component: business,
                    children: [
                        {
                            path: '/business/list',
                            name: 'businessList',
                            component: businessList,
                        }
                    ]
                },
                {
                    // experiment
                    path: '/experiment',
                    redirect: {name: 'experimentList'},
                    component: experiment,
                    children: [
                        {
                            path: '/experiment/list',
                            name: 'experimentList',
                            component: experimentList,
                        }
                    ]
                },
                {
                    // invest
                    path: '/invest',
                    redirect: {name: 'investList'},
                    component: invest,
                    children: [
                        {
                            path: '/invest/list',
                            name: 'investList',
                            component: investList,
                        }
                    ]
                },
                {
                    // about
                    path: '/about',
                    redirect: {name: 'aboutList'},
                    component: about,
                    children: [
                        {
                            path: '/about/list',
                            name: 'aboutList',
                            component: aboutList,
                        }
                    ]
                },
                {
                    // reports
                    path: '/reports',
                    redirect: {name: 'reportsList'},
                    component: reports,
                    children: [
                        {
                            path: '/reports/list',
                            name: 'reportsList',
                            component: reportsList,
                            meta: {
                                requireAuth: true,
                                isSidebar: true,
                            },
                        }
                    ]
                },
                {
                    // user
                    path: '/user',
                    redirect: {name: 'userList'},
                    component: user,
                    children: [
                        {
                            path: '/user/list',
                            name: 'userList',
                            component: userList
                        }
                    ]
                },
            ],
        },

    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js